import { Box, Button, styled, TableCell, Typography } from "@mui/material";

const GreenButton = styled(Button)(({ }) => ({
    backgroundColor: '#01CFBE',
    color: '#FFFFFF',
    borderRadius: '100rem',
    width: "140px",
    height: "35px",
    marginTop: "50px",
    marginRight: "12px",
    marginBottom: "50px",
    fontSize: "16px",
}));

const GreenChoiceButton = styled(Button)(({ }) => ({
    backgroundColor: '#01CFBE',
    color: '#FFFFFF',
    borderRadius: '100rem',
    width: "140px",
    height: "35px",
    marginTop: "50px",
    marginRight: "12px",
    marginBottom: "50px",
    fontSize: "16px",
}));

const ItemLabelBox = styled(Box)(({ }) => ({
    color: '#ffffff',
    backgroundColor: '#595959',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 35,
    width: '8%',
    paddingBottom: '3px',
    position: 'relative',
    top: '8px',
    left: '20px',
    fontSize: '18px',
}));

const GreenContainer = styled(Typography)(({ }) => ({
    border: '1px solid',
    borderColor: '#01CFBE',
    width: '98%',
    paddingBottom: '10px',
    margin: '0 auto'
}));

const ConditionalTableHeadCell = styled(TableCell)(() => ({
    color: '#a7a4a4ff',
    borderBottom: 'none',
    align: 'left',
    padding: '10px 10px',
}));

const ConditionalTableBodyCell = styled(TableCell)(() => ({
    fontSize: '18px',
    borderBottom: '1px solid #a7a4a4ff',
    align: 'left',
    padding: '5px 10px',
}));

export { GreenButton, GreenChoiceButton, ItemLabelBox, GreenContainer, ConditionalTableHeadCell, ConditionalTableBodyCell }
